/** @format */

import { Link } from "react-router-dom";
import { LI, UL } from "../../../AbstractElements";
import { SettingsData } from "../../../Data/Layout/RightHeader";
import SvgIcon from "../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import { logout } from "../../../services/auth";
import { useDispatch } from "react-redux";
import { openView } from "../../../ReduxToolkit/Reducers/viewReducer";

export default function Settings() {
  const dispatch = useDispatch();

  const handleLogout = () => logout();

  const handleViewOpen = (viewName: string) => {
    dispatch(openView(viewName));
  };

  return (
    <LI className="profile-nav onhover-dropdown">
      <i className="fa fa-gear" style={{ color: "white" }}></i>

      <UL className="profile-dropdown onhover-show-div simple-list">
        {SettingsData.map((item, index) => (
          <LI key={index}>
            {item.link === 'event-discounts' ? (
              <Link to={`${process.env.PUBLIC_URL}/${item.link}`}>
                <div className="profile-icon">
                  <SvgIcon iconId={item.icon} />
                </div>
                <span>{item.text}</span>
              </Link>
            ) : (
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleViewOpen(item.link);
                }}
              >
                <div className="profile-icon">
                  <SvgIcon iconId={item.icon} />
                </div>
                <span>{item.text}</span>
              </Link>
            )}
          </LI>
        ))}

        <LI>
          <Link onClick={handleLogout} to={`${process.env.PUBLIC_URL}/login`}>
            <div className="profile-icon">
              <SvgIcon iconId="login" />
            </div>
            <span>{"Log out"}</span>
          </Link>
        </LI>
      </UL>
    </LI>
  );
}
